export default {
    GET_LIST_CART: '[MULTI_CHECKOUT] GET_LIST_CART',
    GOT_LIST_CART: '[MULTI_CHECKOUT] GOT_LIST_CART',
    ADD_CART: '[MULTI_CHECKOUT] ADD_CART',
    ADDED_CART: '[MULTI_CHECKOUT] ADDED_CART',
    SELECT_CART: '[MULTI_CHECKOUT] SELECT_CART',
    SELECTED_CART: '[MULTI_CHECKOUT] SELECTED_CART',
    DELETE_CART: '[MULTI_CHECKOUT] DELETE_CART',
    DELETED_CART: '[MULTI_CHECKOUT] DELETED_CART',
    UPDATE_CART: '[MULTI_CHECKOUT] UPDATE_CART',
    UPDATED_CART: '[MULTI_CHECKOUT] UPDATED_CART',
}



// WEBPACK FOOTER //
// ./src/view/constant/MultiCheckoutConstant.js